import React from "react"

import { Box } from "@chakra-ui/react"
import GanttBar from "../GanttBar"

const GanttBars = ({
  timeLine,
  projectCurrent,
  nodesInfos,
  ganttDurationIndex,
  boxW,
  dispatch,
}) => {
  //=================================================================
  const { nodes, rows } = projectCurrent

  //=================================================================
  const renderGanttBars = () => {
    let renderedGanttBars = rows.map((nId) => {
      // merge nodeInfos from re-select into node
      const node = { ...nodes[nId], ...nodesInfos[nId] }
      return (
        <GanttBar
          key={nId}
          node={node}
          boxW={boxW}
          timeLine={timeLine}
          ganttDurationIndex={ganttDurationIndex}
          dispatch={dispatch}
        />
      )
    })

    return renderedGanttBars
  }

  return <Box>{renderGanttBars()}</Box>
}

export default GanttBars
